export const administrationAccountsDepartmentDetails = {
    template: require('./administration-accounts-department-details.html'),
    controller: 'AdministrationAccountsDepartmentDetailsController'
};
